import React from "react";
import { motion } from "framer-motion";
import { AppContext } from "../../App";

const Image = ({ src, alt }) => {
  const context = React.useContext(AppContext);
  const animationConfig = context.config.animation;
  const imageAnimation = {
    hidden: {
      opacity: 0,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    },
    visible: {
      opacity: 1,
      transition: {
        duration: animationConfig.duration,
        ease: animationConfig.ease
      }
    }
  };
  return (
    <motion.img
      variants={imageAnimation}
      src={src}
      alt={alt}
      className="image"
      initial="hidden"
      animate="visible"
    />
  );
};

export { Image };
